import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BarChart3, ClipboardList, Users } from "lucide-react";

// Galleon Mess census card — official totals (or live roster) at a glance
export default function CensusCard() {
  const { hasRole } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/population/summary").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const s = d.stats;
  const pct = (n) => (s.total ? `${Math.round((n * 1000) / s.total) / 10}%` : "—");
  return (
    <Card className="gold-ring glass p-6" data-testid="census-card">
      <div className="flex items-center gap-2"><Users className="h-5 w-5 text-[hsl(var(--gold))]" /><h3 className="font-display text-lg font-700">Membership Census</h3></div>
      <p className="mt-0.5 text-[0.65rem] uppercase tracking-wider text-muted-foreground">{d.source === "official" ? `Official totals · ${d.report_date ? new Date(d.report_date).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : ""}` : "Live roster"}</p>
      <div className="mt-4 flex items-end gap-3">
        <p className="font-display text-5xl font-800 text-[hsl(var(--gold))]" data-testid="census-card-total">{s.total}</p>
        <div className="pb-1 text-xs text-muted-foreground"><p>brothers on record</p><p><span className="font-700 text-[#2E86DE]">{s.by_status.Sailing}</span> Sailing · <span className="font-700 text-[#F39C12]">{s.by_status.Spot}</span> On Spot{s.by_status.SWGP ? <> · <span className="font-700">{s.by_status.SWGP}</span> SWGP</> : null}</p></div>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-2" data-testid="census-card-frigates">
        {s.frigates.map((f) => (
          <div key={f.label} className="rounded-lg border border-[hsl(var(--gold))]/20 bg-secondary/40 p-2 text-center" data-testid={`census-card-frigate-${f.label}`}>
            <p className="text-[0.6rem] uppercase tracking-wider text-muted-foreground">{f.label}</p>
            <p className="font-display text-2xl font-700">{f.total}</p>
            <p className="text-[0.6rem] text-muted-foreground">{pct(f.total)}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <Link to="/population"><Button size="sm" className="bg-[hsl(var(--gold))] font-700 text-[hsl(var(--primary-foreground))]" data-testid="census-card-open"><BarChart3 className="mr-1.5 h-4 w-4" />Full dashboard</Button></Link>
        {hasRole("officer") && <Link to="/population?tab=census"><Button size="sm" variant="outline" className="gold-ring" data-testid="census-card-edit"><ClipboardList className="mr-1.5 h-4 w-4" />Edit census</Button></Link>}
      </div>
    </Card>
  );
}
